import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

function NavItemLink({text, className, rel}) {
    return (
        <li className={className}>
            <Link className="nav-link" to={rel}>{text}</Link>
        </li>
    );
}

function NavItemHashLink({text, className, rel}) {
    return (
        <li className={className} >
            <HashLink className="nav-link" smooth to={rel}>{text}</HashLink>
        </li>
    );
}

export {NavItemHashLink, NavItemLink};